<template>
  <div class="security-group w-100 p-2 mt-2">
    <page-header>
      <i class="fas fa-list"></i> {{ $t('page.title.player_export') }}
    </page-header>
    <page-card>
      <template v-slot:header>
        {{ $t('title.player_export.options') }}
      </template>
      <template v-slot:content>
        <div class="sygni-grid">
          <div class="row ml-5 mr-5 mt-3 d-flex justify-content-center">
            <div class="col-2">
              {{$t('form.export_player.personal_data')}}
            </div>
            <div class="col-10 mb-3">
              <div class="row mb-3">
                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'first_name')"
                  >
                    {{$t('form.export_player.label.first_name')}}
                  </b-form-checkbox>
                </div>

                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'last_name')"
                  >
                    {{$t('form.export_player.label.last_name')}}
                  </b-form-checkbox>
                </div>
                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'nick_name')"
                  >
                    {{$t('form.export_player.label.nick_name')}}
                  </b-form-checkbox>
                </div>

                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'phone')"
                  >
                    {{$t('form.export_player.label.phone')}}
                  </b-form-checkbox>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'email')"
                  >
                    {{$t('form.export_player.label.email')}}
                  </b-form-checkbox>
                </div>

                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'sex')"
                  >
                    {{$t('form.export_player.label.sex')}}
                  </b-form-checkbox>
                </div>

                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'birth_date')"
                  >
                    {{$t('form.export_player.label.birth_date')}}
                  </b-form-checkbox>
                </div>

                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'country')"
                  >
                    {{$t('form.export_player.label.country')}}
                  </b-form-checkbox>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'city')"
                  >
                    {{$t('form.export_player.label.city')}}
                  </b-form-checkbox>
                </div>
                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'street')"
                  >
                    {{$t('form.export_player.label.street')}}
                  </b-form-checkbox>
                </div>

                <div class="col-3">
                  <b-form-checkbox
                      class="mr-5"
                      @change="setPersonalDataToUrl($event, 'post_code')"
                  >
                    {{$t('form.export_player.label.post_code')}}
                  </b-form-checkbox>
                </div>

                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'locale')"
                  >
                    {{$t('form.export_player.label.locale')}}
                  </b-form-checkbox>
                </div>
              </div>

              <div class="row">
                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'created_at')"
                  >
                    {{$t('form.export_player.label.created_at')}}
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
          
          <div class="row ml-5 mr-5 mt-4 d-flex justify-content-center">
            <div class="col-2">
              {{$t('form.export_player.account_data')}}
            </div>
            <div class="col-10 mb-3">
              <div class="row">
                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'registration_ip')"
                  >
                    {{$t('form.export_player.label.registration_ip')}}
                  </b-form-checkbox>
                </div>

                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'last_login')"
                  >
                    {{$t('form.export_player.label.last_login')}}
                  </b-form-checkbox>
                </div>
                <div class="col-3">
                  <b-form-checkbox
                      @change="setPersonalDataToUrl($event, 'last_login_ip')"
                  >
                    {{$t('form.export_player.label.last_login_ip')}}
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>

          <div class="row ml-5 mr-5 mt-4 d-flex justify-content-center">
            <div class="col-2">
              {{$t('form.export_player.registration_date')}}
            </div>
            <div class="col-10">
              <div class="row">
                <div class="col-5">
                  <filter-date-range-picker
                      :filter-query="filterQuery"
                      :locale="{firstDay: 1, format: 'yyyy-mm-dd'}"
                      :auto="true"
                      :linked="false"
                      :time-picker="true"
                      filter-name="created_at"
                      open-direction="left"

                  >
                  </filter-date-range-picker>
                </div>
              </div>
            </div>
          </div>

          <div class="row ml-5 mr-5 mt-5 d-flex justify-content-center">
            <div class="col-2">
              {{$t('form.export_player.account_status')}}
            </div>
            <div class="col-10 mb-3">
              <div class="row">
                <div class="col-3">
                  <filter-select
                      :filter-query="filterQuery"
                      :options="filterOptions.status"
                      :multiple="false"
                      options-label="text"
                      options-track-by="value"

                      filter-name="status">
                  </filter-select>
                </div>
              </div>
            </div>
          </div>

          <div class="row ml-5 mr-5 mt-2 d-flex justify-content-center">
            <div class="col-2">
              {{$t('form.export_player.account_agreement')}}
            </div>
            <div class="col-10 mb-3">
              <div class="row">
                <div class="col-3">
                  <filter-select
                      :filter-query="filterQuery"
                      :options="filterOptions.agreement3"
                      :multiple="false"
                      options-label="text"
                      options-track-by="value"
                      :label="$t('form.label.export_player.agreement3')"
                      filter-name="agreement3">
                  </filter-select>
                </div>

                <div class="col-3">
                  <filter-select
                      :filter-query="filterQuery"
                      :options="filterOptions.agreement4"
                      :multiple="false"
                      options-label="text"
                      options-track-by="value"
                      :label="$t('form.label.export_player.agreement4')"
                      filter-name="agreement4">
                  </filter-select>
                </div>
              </div>
            </div>
          </div>
        </div>

      </template>

      <template v-slot:footer>
        <b-button @click="exportPlayers()" variant="primary">{{$t('export_player.btn.export')}}</b-button>
      </template>
    </page-card>
  </div>
</template>

<script>
import axios from "axios";
import PageHeader from "../../components/page/PageHeader";
import PageCard from "../../components/page/PageCard";
import FilterSelect from "../../components/grid/filters/FilterSelect";
import FilterDateRangePicker from "../../components/grid/filters/FilterDateRangePicker";
import alertify from "alertifyjs";

export default {
  components: {
    PageHeader,
    PageCard,
    FilterSelect,
    FilterDateRangePicker
  },
  data() {
    return {
      personalDataToUrl: [],
      accountDataToUrl: [],
      filterQuery: [],
      filterOptions: {
        status: [
          {value: 10, text: this.$t('option.export_player.initial')},
          {value: 20, text: this.$t('option.export_player.email_confirmed')},
          {value: 30, text: this.$t('option.export_player.registration_completed')},
          {value: 100, text: this.$t('option.export_player.locked')},
          {value: 900, text: this.$t('option.export_player.deleted')},
        ],
        agreement3: [
          {value: true, text: this.$t('option.export_player.agreement.true')},
          {value: false, text: this.$t('option.export_player.agreement.false')},
        ],
        agreement4: [
          {value: true, text: this.$t('option.export_player.agreement.true')},
          {value: false, text: this.$t('option.export_player.agreement.false')},
        ],
      },
    };
  },
  methods: {
    createFilterQuery() {
      let filter = '';

      Object.keys(this.filterQuery).forEach(key => {
        filter += this.filterQuery[key];
      });

      return filter;
    },
    setPersonalDataToUrl(e, type) {
      if(e) {
        this.personalDataToUrl.push(type);
      } else {
        this.personalDataToUrl = this.personalDataToUrl.filter(item => item !== type);
      }
    },
    exportPlayers() {
      const personalData = this.personalDataToUrl.join(',');
      const accountData = `${this.accountDataToUrl.length ? ',' : ''}${this.accountDataToUrl.join(',')}`;
      const filters = this.createFilterQuery();

      axios.get(`/api/client-security/player/export?dataFields=${personalData}${accountData}${filters}`)
        .then(resp => {
          let url = window.URL.createObjectURL(new Blob([resp.data]));
          let pom = document.createElement('a');
          pom.setAttribute('href', url)
          pom.setAttribute('download', `labels-export-${new Date().getTime()}.csv`);
          pom.click(); // this will download the file
        })
        .catch(() => {
          alertify.error(this.$t('player_export_error'));
        });
    }
  }
}
</script>
